export const UNLOCK_THRESHOLDS = [1, 3, 8] as const;
export const SENSITIVE_CATEGORY_IDS = [
	"health-pharmacy",
	"health-clinic",
	"health-dental",
	"health-oriental",
	"health-checkup",
] as const;
export const RECOVERY_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const RECOVERY_CODE_LENGTH = 24;
export const RECOVERY_GROUP_SIZE = 4;
export const BACKUP_KDF_ITERATIONS = 100_000;
